<template>
    <div class="card mb-4">
        <div class="card-header"><h3>{{ title }}</h3></div>
        <div class="card-body">
            <table class="table text-nowrap">
                <tr v-for="row in numRows" :key="row">
                    <template v-for="column in effectiveNumColumns" :key="column">
                        <template v-if="getValue(row, column) != null">
                            <td class="text-end" style="width: 25%">{{ getLabel(row, column) }}:</td>
                            <td class="text-start" :class="hasDiff(row, column)" style="width: 25%"><b>{{ getValue(row, column) }}</b></td>
                        </template>
                        <template v-else>
                            <td style="width: 25%"></td>
                            <td style="width: 25%"></td>
                        </template>
                    </template>
                </tr>
            </table>
        </div>
    </div>
</template>

<script setup>
import {computed, ref} from "vue";

const props = defineProps({
    title: {
        type: String,
        required: true,
    },
    fields: {
        type: Object,
        required: true,
    },
    compare_to: {
        type: [Object, null],
        required: false,
    },
})

const numRecords = computed(() => Object.keys(props.fields).length);
const numColumns = ref(2);
const numRows = computed(() => Math.ceil( numRecords.value / numColumns.value).valueOf());
const effectiveNumColumns = computed(() => {
    return numRecords.value === 1 ? numColumns.value : numColumns.value;
});

function getLabel(row, column) {
    return getField(row, column).label;
}

function getValue(row, column) {
    let field = getField(row, column);
    if (!field) {
        return null;
    }
    const value = field.display_value ?? field.value;
    if (value === null || value === undefined || value === '') {
        return null;
    }
    if (field.name.includes('_flag')) {
        if (field.value > 0) {
            return 'true';
        }
        return 'false';
    }
    return value;
}

function hasDiff(row, column) {
    let value = getValue(row, column);
    let compare_value = getCompareValue(row, column);
    if( value === null || compare_value === null ) {
        return '';
    }
    if( value != compare_value ) {
        return 'bg-info';
    }
    else {
        return '';
    }
}

function getField(row, column) {
    let index = (column - 1) * numRows.value + (row - 1);
    if (index >= props.fields.length) {
        return null;
    }

    return Object.values(props.fields)[index];
}

function getCompareValue(row, column) {
    if( !props.compare_to ) {
        return null;
    }
    let field = getField(row, column);
    if( !field ) {
        return null;
    }
    let compare_field = props.compare_to[field.name] ?? null;
    if (!compare_field) {
        return null;
    }
    const compareValue = compare_field.display_value ?? compare_field.value;
    if (compareValue === null || compareValue === undefined || compareValue === '') {
        return null;
    }
    if( compare_field.name.includes('_flag') ) {
        if( compare_field.value > 0 ) {
            return 'true';
        }
        return 'false';
    }
    return compareValue;
}
</script>
